interface IToggleSwitchOptions {
    labelId: string;
    switchId: string;
    onText: string;
    offText: string;
    ariaLabel?: string;
    isEnabled?: boolean;
}

export default class ToggleSwitch {
    private readonly labelId: string;
    private readonly switchId: string;
    private readonly ariaLabel: string;
    private readonly onText: string;
    private readonly offText: string;
    private isEnabled = false;

    constructor (options: IToggleSwitchOptions) {
        this.labelId = options.labelId;
        this.switchId = options.switchId;
        this.onText = options.onText;
        this.offText = options.offText;
        this.ariaLabel = options.ariaLabel || "";
        this.isEnabled = options.isEnabled || false;
    }

    create() {
        return `<span class="menu-title-toggle">
                    <span id="${ this.labelId }">${ this.isEnabled ? this.onText : this.offText }</span>
                    <input for="${ this.switchId }" id="${ this.switchId }" class="switch-checkbox" type="checkbox" aria-label="${ this.ariaLabel }" ${ this.isEnabled ? "checked" : "" }>
                    <label for="${ this.switchId }" id="${ this.switchId }-switch" class="switch">
                        <span class="slider"></span>
                    </label>
                </span>`;
    }

    toggle(isEnabled) {
        this.isEnabled = isEnabled;
    }
}